import { ACCESS_LEVEL_STR } from 'pages/User/AccessLevel';
import { GENDER } from 'enum/profile';


export function accessLevelFromShortName(shortName) {
  switch (shortName) {
    case 'u':
      return ACCESS_LEVEL_STR.UNVERIFIED;
    case 'x':
      return ACCESS_LEVEL_STR.GUEST;
    case 'b':
      return ACCESS_LEVEL_STR.GENERAL;
    case 'g':
      return ACCESS_LEVEL_STR.GOLD;
    case 'gf':
    case 'f':
      return ACCESS_LEVEL_STR.GOLD_FREE;
    case 'gp':
    case 'r':
      return ACCESS_LEVEL_STR.GOLD_PROMO;
    case 'p':
      return ACCESS_LEVEL_STR.PERFORMER;
    case 'um':
    case 'e':
      return ACCESS_LEVEL_STR.USER_MODERATOR;
    case 'c':
      return ACCESS_LEVEL_STR.COACH;
    case 'm':
      return ACCESS_LEVEL_STR.MODERATOR;
    case 'a':
      return ACCESS_LEVEL_STR.ADMIN;
    case 'v':
      return ACCESS_LEVEL_STR.VERIFIED_ROOM_MODERATOR;
    default:
      return ACCESS_LEVEL_STR.UNKNOWN;
  }
}

export function genderFromShortName(shortName) {
  switch (shortName) {
    case 'm':
      return GENDER.MALE;
    case 'f':
      return GENDER.FEMALE;
    case 't':
      return GENDER.TRANSGENDER;
    default:
      return GENDER.UNKNOWN;
  }
}

export function isBroadcasting(shortName) {
  switch (shortName) {
    case 'm':
      return true;
    case '0':
      return false;
    default:
      return false;
  }
}
